export const Errors = {
  COMPANY_HAS_USER_WITH_MULTI_PERSONS_COUNT: 'COMPANY_HAS_USER_WITH_MULTI_PERSONS_COUNT',
  GENERIC: 'genericError',
};
